<div
    class="back-to-top w-100 h-100 d-flex flex-column justify-content-center align-items-center p-3"
    (click)="scrollToTop()"
    [ngClass]="{ show: show }"
>
    <app-icon class="arrow mb-1" [type]="'BackToTopArrow'"></app-icon>
    <div class="label">Top</div>
</div>
